import { t } from 'i18next';
import * as yup from 'yup';

import { numberSchemaWithTransform } from 'core/yup';

export const upsertElementSchema = () =>
  yup.object({
    useElementTemplate: yup.boolean().label(t('labelUseElementTemplate')),
    elementTemplate: yup
      .object()
      .label(t('labelElementTemplate'))
      .nullable()
      .when('useElementTemplate', {
        is: true,
        then: yup
          .object()
          .shape({
            customIdentifier: yup.string().label(t('labelElementTemplate')).required(),
          })
          .label(t('labelElementTemplate'))
          .required(),
        otherwise: yup.object().nullable(),
      }),
    elementName: yup
      .string()
      .label(t('labelElementName'))
      .nullable()
      .when('useElementTemplate', {
        is: true,
        then: yup.string().label(t('labelElementName')).nullable().required(),
        otherwise: yup.string().label(t('labelElementName')).nullable(),
      }),
    element: yup
      .object()
      .label(t('labelElementName'))
      .nullable()
      .when('useElementTemplate', {
        is: false,
        then: yup
          .object()
          .shape({ name: yup.string().label(t('labelElementName')).nullable().required() })
          .nullable()
          .required(),
        otherwise: yup
          .object()
          .shape({ name: yup.string().label(t('labelElementName')).nullable() })
          .label(t('labelElementName'))
          .nullable(),
      }),
    quantity: numberSchemaWithTransform()
      .label(t('labelQuantity'))
      .min(0, t('labelQuantity'))
      .required(),
  });
